export default "__VITE_ASSET__84554ecb__"